import React from "react";
import { FiSend } from "react-icons/fi";
import Title from "../../ui/Title";
import BarChart from "./BarChart";

const Balance = ({ darkMode }) => {
  const handlePublicLinkClick = () => {
    window.open("https://resultados.hayllis.com", "_blank");
  };

  const handleCampeonatosClick = () => {
    window.location.href = "https://winscore.perufedup.com/campeonatos";
  };

  return (
    <div className="bg-white p-5 rounded-2xl dark:bg-gray-600 dark:text-gray-300 flex-1">
      <div className="flex justify-between items-center">
        <Title>Sistema de Resultados</Title>
        <FiSend className="bg-gray-500 p-2 rounded-full text-gray-300 w-8 h-8" />
      </div>
      <div>
        <h2 className="font-bold text-2xl mb-2">Accesos Rápidos</h2>
        <button
          type="button"
          onClick={handlePublicLinkClick}
          className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
        >
          Visitar Link Público
        </button>
        <button
          type="button"
          onClick={handleCampeonatosClick}
          className="text-white bg-gradient-to-br from-green-400 to-blue-600 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-green-200 dark:focus:ring-green-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
        >
          Campeonatos
        </button>
        {/* <span>on July 2024</span> */}
      </div>
      <BarChart darkMode={darkMode} />
    </div>
  );
};

export default Balance;
